module.exports = __webpack_public_path__ + "static/img/fivedragons_th.1aaaccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/fivedragons_th.png
// module id = 3cIv
// module chunks = 1